import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const SprayJobCreateWrapper = styled.div`
  width: 100%;
  
  /* ⚠️  REQUIRES className="no-overflow-clip" on the parent
     <LayoutWrapper> — see SprayJobCreate.js render. The default
     LayoutContentWrapper sets overflow:hidden which creates a
     scroll context and silently breaks position:sticky on every
     descendant. If this header stops sticking, check the wrapper
     className first before touching the rules below.

     Sticky offset is 70px to clear the fixed app Topbar
     (Layout/Topbar.js uses position:fixed; height:70). */
  .page-header {
    position: sticky;
    top: 70px;
    z-index: 100;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);

    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    color: #333;
    padding: 16px 24px;
    border-radius: 8px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
  }

  .page-header h1 {
    font-size: 24px;
    margin: 0;
    color: #333;
  }

  .action-buttons {
    display: flex;
    gap: 10px;
  }

  .template-btn {
    background-color: #0B2A1B;
    border: 1px solid #0B2A1B;
    color: white;
  }

  .cancel-btn {
    background-color: transparent;
    border: 1px solid #d9d9d9;
    color: #333;
  }

  .continue-btn {
    background-color: #0B2A1B;
    color: white;
    border: none;
  }

  .btn-success {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    color: white;
  }

  .btn-success:hover {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    color: white;
    opacity: 0.9;
  }

  .btn-success:focus {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    color: white;
    box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2);
  }

  .btn-success:disabled {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    color: white;
    opacity: 0.5;
  }

  .cancel-button {
    background-color: transparent;
    border: 1px solid #d9d9d9;
    color: #333;
  }

  .cancel-button:hover {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: #333;
  }

  .cancel-button:focus {
    background-color: transparent;
    border-color: #d9d9d9;
    color: #333;
    box-shadow: 0 0 0 2px rgba(217, 217, 217, 0.2);
  }

  .customize-btn, .ant-btn.customize-btn {
    background-color: transparent !important;
    border: 1px solid #0B2A1B !important;
    color: #0B2A1B !important;
    height: 40px !important;
    line-height: 30px !important;
  }

  .customize-btn:hover, .ant-btn.customize-btn:hover {
    background-color: #0B2A1B !important;
    border-color: #0B2A1B !important;
    color: white !important;
    height: 40px !important;
    line-height: 30px !important;
  }

  .customize-btn:focus, .ant-btn.customize-btn:focus {
    background-color: transparent !important;
    border-color: #0B2A1B !important;
    color: #0B2A1B !important;
    box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2) !important;
    height: 40px !important;
    line-height: 30px !important;
  }

  .customize-btn:disabled, .ant-btn.customize-btn:disabled {
    background-color: transparent !important;
    border-color: #d9d9d9 !important;
    color: #d9d9d9 !important;
    height: 40px !important;
    line-height: 30px !important;
  }

  /* Global styles for modal footers */
  .ant-modal-footer .customize-btn {
    background-color: transparent !important;
    border: 1px solid #0B2A1B !important;
    color: #0B2A1B !important;
    height: 40px !important;
    line-height: 30px !important;
  }

  .ant-modal-footer .customize-btn:hover {
    background-color: #0B2A1B !important;
    border-color: #0B2A1B !important;
    color: white !important;
  }

  .ant-modal-footer .customize-btn:disabled {
    background-color: transparent !important;
    border-color: #d9d9d9 !important;
    color: #d9d9d9 !important;
  }

  .spray-job-form {
    padding: 0 24px 24px;
    max-width: 800px;
    margin: 0 auto;
  }

  .form-section {
    margin-bottom: 24px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e0e0e0;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .zone-label, .chemical-label, .section-label {
    margin-bottom: 0;
  }

  .zone-add-button, .chemical-add-button {
    display: flex;
    align-items: center;
  }

  .zone-row {
    margin-bottom: 12px;
  }

  .chemical-info {
    margin-top: 16px;
    font-size: 13px;
    color: #666;
  }

  .rate-info, .formulation-info, .total-mixed-info {
    margin-bottom: 4px;
  }

  .selected-zones-list {
    background: #f9f9f9;
    padding: 12px;
    border-radius: 4px;
    margin-top: 8px;
  }

  .ant-select, .ant-input, .ant-input-number {
    width: 100%;
  }

  .ant-select-selector {
    border-radius: 4px !important;
  }

  .ant-input, .ant-input-number {
    border-radius: 4px !important;
  }

  .ant-checkbox-wrapper {
    margin-left: 8px;
  }
  
  input {
    border: 1px solid rgb(208, 213, 221) !important;
  }
  .ant-picker-input input, .ant-input-number {
    border: none !important;
  }
  .ant-picker {
    border: 1px solid rgb(208, 213, 221) !important;
  }
  .ant-select-selector {
    border: 1px solid rgb(208, 213, 221) !important;
  }
  .ant-select {
    border: none !important;
    box-shadow: none !important;
  }
  .ant-input-group > .ant-input:first-child, .ant-input-group-addon:first-child {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .ant-input-number-group > .ant-input-number:first-child, .ant-input-number-group-addon:first-child {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .ant-input-number-group input {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,
  .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover,
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
    border: 1px solid #ff4d4f !important;
  }

  .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number input,
  .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover input,
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input input,
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover input {
    border: none !important;
  }
  .zone-select .ant-select-selector input {
    border: none !important;
    box-shadow: none !important;
  }
  .chemical-select .ant-select-selector {
    border: 1px solid rgb(208, 213, 221) !important;
    box-shadow: none !important;
    border-radius: 6px !important;
  }
  .chemical-select .ant-select-selector:hover,
  .chemical-select.ant-select-focused .ant-select-selector,
  .chemical-select.ant-select-open .ant-select-selector {
    border-color: #1890ff !important;
    box-shadow: none !important;
  }
  .chemical-select .ant-select-selector input {
    border: none !important;
    box-shadow: none !important;
  }
  .chemical-select.ant-select-status-error .ant-select-selector {
    border-color: #ff4d4f !important;
  }
  .chemical-select .ant-select-selection-item {
    padding: 0 12px !important;
    line-height: 38px !important;
  }
  .chemical-select .ant-select-selection-placeholder {
    padding: 0 12px !important;
    line-height: 38px !important;
  }

  /* Responsive styling for different screen sizes */
  @media only screen and (max-width: 992px) {
    .spray-job-form {
      max-width: 100%;
      padding: 0;
    }
  }

  @media only screen and (max-width: 768px) {
    .page-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;
    }
    
    .action-buttons {
      margin-top: 12px;
      width: 100%;
      justify-content: space-between;
    }

    .continue-btn, .cancel-btn, .template-btn {
      flex: 1;
    }

    .form-section {
      padding: 12px;
    }
  }

  @media only screen and (max-width: 576px) {
    .page-header h1 {
      font-size: 20px;
    }

    .action-buttons {
      flex-direction: column;
      gap: 8px;
    }

    .action-buttons button {
      width: 100%;
    }

    .ant-form-item-label > label {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 480px) {
    .spray-job-form {
      padding: 0 10px 10px;
    }

    .form-section {
      padding: 10px;
    }

    .ant-form-item {
      margin-bottom: 12px;
    }
  }
`;

export default WithDirection(SprayJobCreateWrapper);
